export default {
  state: {
    getCode: localStorage.getItem('code') || null,
  },
  getters: {
    getCode: state => state.getCode,
  },
  mutations: {
    UPDATE_CODE(state, data) {
      localStorage.setItem('code', data)
      state.getCode = data
    },
  },
  actions: {
  },
}
